export default "__VITE_ASSET__CiBYARxZ__"